'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SoundBleep = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SoundBleep = exports.SoundBleep = function () {
    function SoundBleep() {
        (0, _classCallCheck3.default)(this, SoundBleep);

        this.audio = document.createElement('audio');
        var source = document.createElement('source');

        if (this.audio.canPlayType('audio/mpeg;')) {
            source.type = 'audio/mpeg';
            source.src = 'static/highlight.mp3';
        } else {
            source.type = 'audio/ogg';
            source.src = 'static/highlight.ogg';
        }

        this.audio.appendChild(source);
    }

    (0, _createClass3.default)(SoundBleep, [{
        key: 'play',
        value: function play() {
            this.audio.play();
        }
    }]);
    return SoundBleep;
}();


//////////////////
// WEBPACK FOOTER
// ./src/libs/SoundBleep.js
// module id = YX3V
// module chunks = 1